import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import store from '../../../store';
import deleteItem from './deleteItem';
import loadItem from './loadItem';
import createItem from './createItem';
import renameItem from './renameItem';
import updateItem from './updateItem';
import _useItem from './useItem';
import placeholders from '../../placeholders';
import dataGridAction from '../grid';
import dataListAction from '../list';
import capitalize from '../../../utils/formatting/capitalize';
import ACTIONS from '../../../store/actions';
import Modal from '../../../modal';
import deepMerge from '../../../utils/deepMerge';
/**
 * @type {import('../types').DataActionItem}
 */

var dataItemActions = function dataItemActions(itemIdentifier) {
  return {
    create: function create(data) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS,
          refresh = _ref.refresh;

      return store.dispatch(createItem(data, itemIdentifier)).then(function (action) {
        if (action.type === ACTIONS.ITEM_CREATE_RESOLVED) if (refresh) refreshItem(itemIdentifier);
        return action;
      });
    },
    fetch: function fetch() {
      return store.dispatch(loadItem(itemIdentifier));
    },
    refresh: function refresh() {
      return store.dispatch(loadItem(itemIdentifier));
    },
    useItem: function useItem() {
      return _useItem(itemIdentifier.dataType, itemIdentifier.id);
    },
    update: function update(data) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS,
          refresh = _ref2.refresh;

      return store.dispatch(updateItem(data, itemIdentifier)).then(function (action) {
        if (action.type === ACTIONS.ITEM_UPDATE_RESOLVED) if (refresh) {
          updateAuth(data, itemIdentifier);
          refreshItem(itemIdentifier);
        }
        return action;
      });
    },
    delete: function _delete() {
      var userOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_OPTIONS;

      var _DEFAULT_OPTIONS$user = _objectSpread({}, DEFAULT_OPTIONS, userOptions),
          useConfirmation = _DEFAULT_OPTIONS$user.useConfirmation,
          refresh = _DEFAULT_OPTIONS$user.refresh,
          rest = _objectWithoutProperties(_DEFAULT_OPTIONS$user, ["useConfirmation", "refresh"]);
      /** When using confirmation, the promise response will never be rejected */


      if (useConfirmation) {
        return new Promise(function (resolve, reject) {
          return Modal.open({
            type: Modal.TYPES.DELETE_CONFIRMATION,
            props: _objectSpread({
              title: placeholders('{delete} {type}', itemIdentifier),
              message: placeholders('Are you sure you want to {delete} {type}?', itemIdentifier),
              submitLabel: placeholders('{delete}', itemIdentifier),
              submittingLabel: placeholders('{deleting}', itemIdentifier),
              onDelete: function onDelete() {
                return store.dispatch(deleteItem(itemIdentifier)).then(function (action) {
                  if (action.payload && action.payload.error) {
                    throw action;
                  } else {
                    resolve(action);
                    if (refresh) refreshCollection(itemIdentifier);
                    return action;
                  }
                });
              }
            }, rest)
          });
        });
      } else {
        return store.dispatch(deleteItem(itemIdentifier)).then(function (action) {
          if (action.payload && action.payload.error) throw action;else {
            if (refresh) refreshCollection(itemIdentifier);
            return action;
          }
        });
      }
    },
    save: function save(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
      if (itemIdentifier.id) return dataItemActions(itemIdentifier).update(data, options);else return dataItemActions(itemIdentifier).create(data, options);
    },
    rename: function rename() {
      var userOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_OPTIONS;

      var options = _objectSpread({}, DEFAULT_OPTIONS, userOptions);

      if (!options.name) {
        /** When using confirmation, the promise response will never be rejected */
        return new Promise(function (resolve) {
          var overrideProps = {};
          if (options && options.modalProps) overrideProps = options.modalProps;
          Modal.open({
            type: Modal.TYPES.PROMPT_INPUT,
            props: deepMerge({
              windowProps: {
                header: placeholders('Rename {label}', itemIdentifier)
              },
              formFieldType: 'Name',
              formField: {
                selectOnFocus: true,
                defaultValue: placeholders('{label}', itemIdentifier),
                label: capitalize(placeholders('{type} Name', itemIdentifier)),
                placeholder: placeholders('Name of the {type}', itemIdentifier)
              },
              submitLabel: 'Rename',
              submittingLabel: 'Renaming..',
              onSubmit: function onSubmit(newName) {
                return store.dispatch(renameItem(newName, itemIdentifier)).then(function (action) {
                  if (action.payload && action.payload.error) {
                    throw action;
                  } else {
                    resolve(action);
                    if (options.refresh) refreshItem(itemIdentifier);
                    return action;
                  }
                });
              }
            }, overrideProps)
          });
        });
      } else {
        return store.dispatch(renameItem(name, itemIdentifier)).then(function (action) {
          if (action.payload && action.payload.error) throw action;else return action;
        });
      }
    }
  };
};

var DEFAULT_OPTIONS = {
  refresh: true
};

var refreshCollection = function refreshCollection(itemIdentifier) {
  dataGridAction({
    dataType: itemIdentifier.dataType
  }).refresh();
  dataListAction({
    dataType: itemIdentifier.dataType
  }).refresh();
};

var refreshItem = function refreshItem(itemIdentifier) {
  refreshCollection(itemIdentifier);
  if (itemIdentifier.id) dataItemActions(itemIdentifier).refresh();
};

var updateAuth = function updateAuth(data, itemIdentifier) {
  if (itemIdentifier.dataType === 'organization') {
    store.dispatch({
      type: ACTIONS.AUTH_SET,
      payload: {
        environmentName: data.Name
      }
    });
  }
};

export default dataItemActions;